export default {
    iWant: 'Eu quero',
    unblock: 'Desbloquear',
    calendars: 'Calendário Astrológico e Lunar',
    predictions: 'Previsões Pessoais e Mundiais',
    articles: 'Artigos, Tarot, Rituais e Simpatias',
};